export default __webpack_public_path__ + "static/media/notes.4dd1b2db.svg";